import Grid from "@components/Grid/Grid";
import { SettingsContext } from "@utilities/context/settings";
import { useContext } from "react";
import styles from "./Error.module.scss";

export const GenericApiError = () => {
  const { siteSettings } = useContext(SettingsContext);

  return (
    <div className={`wrapper ${styles.errorWrapper}`}>
      <Grid row>
        <Grid column sm={8}>
          <p className={styles["Error"]}>{siteSettings?.genericApiError}</p>
        </Grid>
      </Grid>
    </div>
  );
};

export default GenericApiError;
